import { useStoreState } from "easy-peasy"

const Footer = () => {
	const EnvSuffix = useStoreState((state) => state.EnvSuffix)

	return (
		<footer className="Footer">
			<div style={{ display: "flex", width: "100%", padding: "0 0.75rem", boxSizing: "border-box", fontSize: "1.0rem" }}>
				<div style={{ flex: 1, textAlign: "left", whiteSpace: "nowrap" }}>
					version 1.15{EnvSuffix ? ` - ${EnvSuffix}` : ""}
				</div>
				<div style={{ flex: 1, textAlign: "center", whiteSpace: "nowrap" }}>
					&copy; {new Date().getFullYear()} CR Cloud Technology LLC. All rights reserved.
				</div>
				<div style={{ flex: 1 }} />
			</div>
		</footer>
	)
}

export default Footer
